import VocabContextProvider from './VocabContextProvider'

export default VocabContextProvider
